import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { I18nProvider } from './i18n';
import Home from './pages/Home';
import ComingSoon from './pages/ComingSoon';
import ResetPassword from './pages/ResetPassword';
import Confidentialite from './pages/Confidentialite';
import Support from './pages/Support';
import MentionsLegales from './pages/MentionsLegales';

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/bientot-disponible" element={<ComingSoon />} />
              <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/support" element={<Support />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
